// Layout Templates - Predefined layout configurations
// These are geometry-only templates; sources are assigned via presets
// 2-Way Horizontal (side by side)
const twoWayHorizontal = {
    id: "2-way-horizontal",
    name: "2-Way Horizontal",
    description: "Two sources side by side, split vertically",
    boxes: [
        {
            position: 0,
            enabled: true,
            label: "Left",
            x: 0.25,
            y: 0.5,
            width: 0.5,
            height: 1.0,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 1,
            enabled: true,
            label: "Right",
            x: 0.75,
            y: 0.5,
            width: 0.5,
            height: 1.0,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
    ],
    art_enabled: false,
    art_placement: "foreground",
    border_enabled: false,
};
// 2-Way Vertical (top and bottom)
const twoWayVertical = {
    id: "2-way-vertical",
    name: "2-Way Vertical",
    description: "Two sources stacked vertically",
    boxes: [
        {
            position: 0,
            enabled: true,
            label: "Top",
            x: 0.5,
            y: 0.25,
            width: 1.0,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 1,
            enabled: true,
            label: "Bottom",
            x: 0.5,
            y: 0.75,
            width: 1.0,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
    ],
    art_enabled: false,
    art_placement: "foreground",
    border_enabled: false,
};
// 3-Way Large Left (large source on left, two small on right)
const threeWayLargeLeft = {
    id: "3-way-large-left",
    name: "3-Way Large Left",
    description: "One large source on the left, two smaller sources stacked on the right",
    boxes: [
        {
            position: 0,
            enabled: true,
            label: "Main",
            x: 0.3333,
            y: 0.5,
            width: 0.6667,
            height: 1.0,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 1,
            enabled: true,
            label: "Top Right",
            x: 0.8333,
            y: 0.25,
            width: 0.3333,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 2,
            enabled: true,
            label: "Bottom Right",
            x: 0.8333,
            y: 0.75,
            width: 0.3333,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
    ],
    art_enabled: false,
    art_placement: "foreground",
    border_enabled: false,
};
// 3-Way Large Right (two small on left, large source on right)
const threeWayLargeRight = {
    id: "3-way-large-right",
    name: "3-Way Large Right",
    description: "Two smaller sources stacked on the left, one large source on the right",
    boxes: [
        {
            position: 0,
            enabled: true,
            label: "Top Left",
            x: 0.1667,
            y: 0.25,
            width: 0.3333,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 1,
            enabled: true,
            label: "Bottom Left",
            x: 0.1667,
            y: 0.75,
            width: 0.3333,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 2,
            enabled: true,
            label: "Main",
            x: 0.6667,
            y: 0.5,
            width: 0.6667,
            height: 1.0,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
    ],
    art_enabled: false,
    art_placement: "foreground",
    border_enabled: false,
};
// 4-Way Grid (2x2)
const fourWayGrid = {
    id: "4-way-grid",
    name: "4-Way Grid",
    description: "Four sources in a 2x2 grid",
    boxes: [
        {
            position: 0,
            enabled: true,
            label: "Top Left",
            x: 0.25,
            y: 0.25,
            width: 0.5,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 1,
            enabled: true,
            label: "Top Right",
            x: 0.75,
            y: 0.25,
            width: 0.5,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 2,
            enabled: true,
            label: "Bottom Left",
            x: 0.25,
            y: 0.75,
            width: 0.5,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
        {
            position: 3,
            enabled: true,
            label: "Bottom Right",
            x: 0.75,
            y: 0.75,
            width: 0.5,
            height: 0.5,
            crop_top: 0,
            crop_bottom: 0,
            crop_left: 0,
            crop_right: 0,
        },
    ],
    art_enabled: false,
    art_placement: "foreground",
    border_enabled: false,
};
// PiP dimensions and positions (small box is 25% of screen width)
const PIP_SIZE = 0.25;
const PIP_MARGIN = 0.05;
const PIP_X_RIGHT = 1 - PIP_MARGIN - PIP_SIZE / 2;
const PIP_X_LEFT = PIP_MARGIN + PIP_SIZE / 2;
// A 16:9 box has the same width and height fraction, so half its height is
// PIP_SIZE / 2 of the frame height as well.
const PIP_Y_BOTTOM = 1 - PIP_MARGIN - PIP_SIZE / 2;
const PIP_Y_TOP = PIP_MARGIN + PIP_SIZE / 2;
/**
 * Picture-in-picture: the PiP is the top layer, the fullscreen main source
 * the bottom layer. (The PiP used to be box 2, below the fullscreen box 1,
 * which hid it: the switcher draws box 1 on top.)
 */
function pipTemplate(id, name, corner, x, y) {
    return {
        id,
        name,
        description: `Main source with a small picture-in-picture in the ${corner}`,
        boxes: [
            {
                position: 0,
                enabled: true,
                label: "PiP",
                x,
                y,
                width: PIP_SIZE,
                height: PIP_SIZE,
                crop_top: 0,
                crop_bottom: 0,
                crop_left: 0,
                crop_right: 0,
            },
            {
                position: 1,
                enabled: true,
                label: "Main",
                x: 0.5,
                y: 0.5,
                width: 1.0,
                height: 1.0,
                crop_top: 0,
                crop_bottom: 0,
                crop_left: 0,
                crop_right: 0,
            },
        ],
        art_enabled: false,
        art_placement: "foreground",
        border_enabled: false,
    };
}
const pipBottomRight = pipTemplate("pip-bottom-right", "PiP Bottom Right", "bottom right", PIP_X_RIGHT, PIP_Y_BOTTOM);
const pipBottomLeft = pipTemplate("pip-bottom-left", "PiP Bottom Left", "bottom left", PIP_X_LEFT, PIP_Y_BOTTOM);
const pipTopRight = pipTemplate("pip-top-right", "PiP Top Right", "top right", PIP_X_RIGHT, PIP_Y_TOP);
const pipTopLeft = pipTemplate("pip-top-left", "PiP Top Left", "top left", PIP_X_LEFT, PIP_Y_TOP);
// Map of all templates by ID
export const LAYOUT_TEMPLATES = {
    "2-way-horizontal": twoWayHorizontal,
    "2-way-vertical": twoWayVertical,
    "3-way-large-left": threeWayLargeLeft,
    "3-way-large-right": threeWayLargeRight,
    "4-way-grid": fourWayGrid,
    "pip-bottom-right": pipBottomRight,
    "pip-bottom-left": pipBottomLeft,
    "pip-top-right": pipTopRight,
    "pip-top-left": pipTopLeft,
};
// Get a template by ID
export function getLayoutTemplate(id) {
    return LAYOUT_TEMPLATES[id];
}
// Get all templates as an array
export function getAllLayoutTemplates() {
    return Object.values(LAYOUT_TEMPLATES);
}
// Get templates filtered by number of boxes
export function getLayoutTemplatesByBoxCount(count) {
    return getAllLayoutTemplates().filter((t) => t.boxes.length === count);
}
